<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p
            style="margin-top:0pt; margin-bottom:20px; text-indent:7pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:14pt">
            <span
              style="font-family:'宋体'; font-size:18px; font-weight:bold">吉林亿联银行个人贷款资金支付委托书</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; "><span
              style="font-family:'宋体'; font-weight:bold">吉林亿联银行股份有限公司</span><span
              style="font-family:'宋体'; font-weight:bold">：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">根据</span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; ">年</span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; ">月</span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; ">日与贵行签订的个人借款合同（下称借款合同），我方已完成了借款合同约定的所有提款前提条件，特向贵行发出该不可撤销提款申请：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">一、委托贵行于放款日后3个工作日内将</span><span
              style="font-family:'宋体'; text-decoration:underline">人民币</span><span
              style="font-family:'宋体'; ">（币种）</span><span style="font-family:'宋体'; "> </span><span
              style="font-family:'宋体'; ">（</span><span style="font-family:'宋体'; ">大写：</span><span
              style="font-family:'宋体'; text-decoration:underline"> </span><span
              style="font-family:'宋体'; ">)</span><span
              style="font-family:'宋体'; ">划入以下支付对象账户：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">账号：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">户名：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">开户行：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">二、该笔借款的利率、期限、到期日以借款合同记载为准。</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">三、在该提款通知发出之日，我方确认：</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">1、该次提款将用于借款合同所约定的借款用途；</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">2、我方在借款合同中所作陈述、保证和承诺真实、准确、完整、有效；</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">3、不存在任何借款合同项下或与借款合同有关的违约或预期违约事件。</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; ">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; ">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; "> 借款人（签章）：</span><span
              style="font-family:'宋体'; text-decoration:underline"> </span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; ">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; "><span
              style="font-family:'宋体'"> 年 月 日</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; ">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:20pt; widows:0; orphans:0"><span
              style="font-family:'宋体'; ">&#xa0;</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:72pt; text-align:justify; line-height:20pt; widows:0; orphans:0">
            <span style="font-family:'宋体'; ">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:14pt"><span
              style="font-family:Calibri; font-weight:bold">&#xa0;</span></p>
          <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt"><span
              style="font-family:Calibri">&#xa0;</span></p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:20.25pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
            <span style="font-family:'宋体'">&#xa0;</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Button from '@/components/Button.vue';

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {},
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
